/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerSound} from "../../../sound/LonerSound";
import {gsap} from "gsap";

export class LonerTickTickBoomOutroPresentation implements SimplePresentation {

    protected _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return Loner.model.data.mode == LonerGameMode.FEATURE_TICK_TICK_BOOM
            && Loner.model.data.nextMode == LonerGameMode.NORMAL;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const mainTL:gsap.core.Timeline = gsap.timeline();
        const amount:number = Loner.model.accumulatedRoundWin;//(Loner.model.gameData.playedBetValue * Loner.model.timesBetWinDraw);

        let countDuration:number = 1.5;

        if (amount < 100){
            countDuration = 1.5;
        }else if (amount < 500){
            countDuration = 2.5;
        }else if (amount < 1000){
            countDuration = 3.5;
        }else{
            countDuration = 4.0;
        }

        if(Loner.model.brokeBank == true) {
            countDuration = 5;
        }

        let aborted:boolean = false;

        const isWinBelowStake:boolean = Loner.isWinBelowStake();

        if(!isWinBelowStake) {
            mainTL.add(() => {
                //BenjiKIV.soundPlayer.playSound(TrueGritSound.FS_OUTRO_LOW_WIN);
            });
        }

        mainTL.add(Loner.tickTickBoomOutroView.showOutro(() => this.ttbOutroClosedCallback(controller, isWinBelowStake)));
        if(!isWinBelowStake) {
            mainTL.add(() => {
                Loner.soundPlayer.fadeMusic(0, 0, 0);
                if(Loner.model.wasFeatureBuy == true) {
                    if(amount < (Loner.getBuyFeaturePrice() * 0.10)) {
                        //Loner.soundPlayer.playSound(LonerSound.FS_ENDS_BAD);
                    } else {
                        //Loner.soundPlayer.playSound(LonerSound.FS_ENDS_GOOD);
                    }
                } else {
                    if(amount < (Loner.model.gameData.playedBetValue * 5)) {
                        //Loner.soundPlayer.playSound(LonerSound.FS_ENDS_BAD);
                    } else {
                        //Loner.soundPlayer.playSound(LonerSound.FS_ENDS_GOOD);
                    }
                }
            });
        }
        mainTL.add(() => controller.setSkipCallback(() => {
            aborted = true;
            mainTL.seek("end", false);
        }));
        mainTL.add(Loner.tickTickBoomView.getShowCreditsBackgroundTL());
        mainTL.add(Loner.tickTickBoomOutroView.getCountUp(amount, countDuration, isWinBelowStake));
        if(Loner.model.brokeBank == true) {
            mainTL.add(Loner.tickTickBoomOutroView.showMaxWinText());
        } else {
            mainTL.add(Loner.tickTickBoomOutroView.showBetText());
        }
        mainTL.addLabel("end");
        mainTL.add(() => {Loner.tickTickBoomView.startCredits()}, "+=0.2");
        mainTL.add(() => {Loner.soundPlayer.stopSound(LonerSound.TTB_MUSIC)});
        mainTL.add(() => {Loner.soundPlayer.playSound(LonerSound.TTB_OUTRO_MUSIC, 1, 10000)});
        mainTL.add(() => controller.setSkipCallback());
        mainTL.add(Loner.tickTickBoomOutroView.showButton());
    }

    private ttbOutroClosedCallback(controller:SimplePresentationRunnerController, isWinBelowStake:boolean):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});
        tl.add(() => {
            if(Loner.model.brokeBank){
                Loner.soundPlayer.playSound(LonerSound.GM_BACK_TO_MAIN_GAME);
            }else {
                Loner.soundPlayer.playSound(LonerSound.CONTINUE_BUTTON);
                Loner.soundPlayer.playSound(LonerSound.TTB_BACK_TO_MAIN);
            }
        });
        tl.add(() => {
            Loner.soundPlayer.stopSound(LonerSound.TTB_OUTRO_MUSIC);
            Loner.foregroundView.setMode(LonerGameMode.BACK_FROM_TTB);
        });
        tl.add([
            Loner.tickTickBoomOutroView.hideOutro(isWinBelowStake),
            Loner.tickTickBoomView.getHideViewTL()
        ]);
        tl.add(() => Loner.tickTickBoomView.reset());
        tl.add(
            () => {
                Loner.soundPlayer.fadeMusic(0, 1, 1000);
                Loner.soundPlayer.switchMusic(LonerGameMode.NORMAL);
            }
        );
    }
}